export enum DirectoryEntities {
    ADDRESS_BOOK_LIST= 'addressBookList',
    SKILL_LIST= 'skillList',
    AGENT_LIST= 'agentList',
}